module.exports = __webpack_public_path__ + "media/images/front/samples-23057bb28e7be07015cd34b0a3fff551.webp";